var map = {
	"./arrowLeft.svg": "./web/themes/custom/wasbar_v2/dev/icons/arrowLeft.svg",
	"./arrowRight.svg": "./web/themes/custom/wasbar_v2/dev/icons/arrowRight.svg",
	"./bottom-shape-quote.svg": "./web/themes/custom/wasbar_v2/dev/icons/bottom-shape-quote.svg",
	"./bottom-shape.svg": "./web/themes/custom/wasbar_v2/dev/icons/bottom-shape.svg",
	"./btn-shape--blue.svg": "./web/themes/custom/wasbar_v2/dev/icons/btn-shape--blue.svg",
	"./btn-shape--border.svg": "./web/themes/custom/wasbar_v2/dev/icons/btn-shape--border.svg",
	"./btn-shape--gold.svg": "./web/themes/custom/wasbar_v2/dev/icons/btn-shape--gold.svg",
	"./btn-shape--white.svg": "./web/themes/custom/wasbar_v2/dev/icons/btn-shape--white.svg",
	"./btn-shape-v-flip.svg": "./web/themes/custom/wasbar_v2/dev/icons/btn-shape-v-flip.svg",
	"./btn-shape.svg": "./web/themes/custom/wasbar_v2/dev/icons/btn-shape.svg",
	"./chevron-down.svg": "./web/themes/custom/wasbar_v2/dev/icons/chevron-down.svg",
	"./close.svg": "./web/themes/custom/wasbar_v2/dev/icons/close.svg",
	"./deliveroo.svg": "./web/themes/custom/wasbar_v2/dev/icons/deliveroo.svg",
	"./email.svg": "./web/themes/custom/wasbar_v2/dev/icons/email.svg",
	"./facebook.svg": "./web/themes/custom/wasbar_v2/dev/icons/facebook.svg",
	"./instagram.svg": "./web/themes/custom/wasbar_v2/dev/icons/instagram.svg",
	"./linkedin.svg": "./web/themes/custom/wasbar_v2/dev/icons/linkedin.svg",
	"./location-blob.svg": "./web/themes/custom/wasbar_v2/dev/icons/location-blob.svg",
	"./logo--text.svg": "./web/themes/custom/wasbar_v2/dev/icons/logo--text.svg",
	"./logo-icon.svg": "./web/themes/custom/wasbar_v2/dev/icons/logo-icon.svg",
	"./logo.svg": "./web/themes/custom/wasbar_v2/dev/icons/logo.svg",
	"./minsky-logo.svg": "./web/themes/custom/wasbar_v2/dev/icons/minsky-logo.svg",
	"./phone.svg": "./web/themes/custom/wasbar_v2/dev/icons/phone.svg",
	"./play.svg": "./web/themes/custom/wasbar_v2/dev/icons/play.svg",
	"./plus.svg": "./web/themes/custom/wasbar_v2/dev/icons/plus.svg",
	"./submenu-shape.svg": "./web/themes/custom/wasbar_v2/dev/icons/submenu-shape.svg",
	"./takeaway.svg": "./web/themes/custom/wasbar_v2/dev/icons/takeaway.svg",
	"./tiktok.svg": "./web/themes/custom/wasbar_v2/dev/icons/tiktok.svg",
	"./top-shape-mobile.svg": "./web/themes/custom/wasbar_v2/dev/icons/top-shape-mobile.svg",
	"./top-shape-quote.svg": "./web/themes/custom/wasbar_v2/dev/icons/top-shape-quote.svg",
	"./top-shape.svg": "./web/themes/custom/wasbar_v2/dev/icons/top-shape.svg",
	"./top-shape2.svg": "./web/themes/custom/wasbar_v2/dev/icons/top-shape2.svg",
	"./uber.svg": "./web/themes/custom/wasbar_v2/dev/icons/uber.svg",
	"./youtube.svg": "./web/themes/custom/wasbar_v2/dev/icons/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./web/themes/custom/wasbar_v2/dev/icons sync recursive \\.svg$";